import { useState } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { KeyRound, LogOut, UserCircle2, UsersRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ChangePasswordDialog } from "./ChangePasswordDialog";
import { UsersDialog } from "./UsersDialog";

export const UserMenu = () => {
  const { user, logout } = useAuth();
  const [pwdOpen, setPwdOpen] = useState(false);
  const [usersOpen, setUsersOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button data-testid="user-menu-btn" variant="outline" className="h-10 gap-2 rounded-xl px-2.5 sm:px-4" aria-label="Account">
            <UserCircle2 className="h-4 w-4" />
            <span className="hidden max-w-[120px] truncate xl:inline">{user.name}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56 rounded-xl">
          <DropdownMenuLabel className="font-normal">
            <p className="truncate text-sm font-semibold">{user.name}</p>
            <p data-testid="user-menu-email" className="truncate text-xs text-slate-500">{user.email}</p>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {user.role === "admin" && (
            <DropdownMenuItem data-testid="user-menu-users" onSelect={() => setUsersOpen(true)}>
              <UsersRound className="mr-2 h-4 w-4" /> Utenti autorizzati
            </DropdownMenuItem>
          )}
          <DropdownMenuItem data-testid="user-menu-password" onSelect={() => setPwdOpen(true)}>
            <KeyRound className="mr-2 h-4 w-4" /> Cambia password
          </DropdownMenuItem>
          <DropdownMenuItem data-testid="user-menu-logout" onSelect={logout} className="text-rose-600 focus:text-rose-700">
            <LogOut className="mr-2 h-4 w-4" /> Esci
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ChangePasswordDialog open={pwdOpen} onOpenChange={setPwdOpen} />
      {user.role === "admin" && <UsersDialog open={usersOpen} onOpenChange={setUsersOpen} currentUser={user} />}
    </>
  );
};
